'use strict';

exports.newGuid = function () {
  var n;
  var i;
  var guidArray = [];

  for (i = 1; i <= 32; i++) {
    n = Math.floor(Math.random() * 16.0).toString(16);
    guidArray.push(n);

    if ((i == 8) || (i == 12) || (i == 16) || (i == 20))
      guidArray.push('-');
  }

  return guidArray.join('');
};


exports.extendObj = function (destination) {
  var resultObj = {};
  var key;
  var index;
  var source;

  if (destination) {
    for (key in destination) {
      resultObj[key] = destination[key];
    }
  }

  var length = arguments.length;
  if (length >= 2) {
    for (index = 1; index < length; index++) {
      source = arguments[index];
      for (key in source) {
        if(source[key] !== undefined) {
          resultObj[key] = source[key];
        }
      }
    }
  }

  return resultObj;

};




// WEBPACK FOOTER //
// ./src/helper/tool.js